import React from 'react';
import { useNavigate } from 'react-router-dom';

interface GameHeaderProps {
  score: number;
}

export const GameHeader: React.FC<GameHeaderProps> = ({ score }) => {
  const navigate = useNavigate();

  return (
    <header className="flex justify-between items-center">
      <button
        onClick={() => navigate('/dashboard')}
        className="text-white hover:opacity-80 transition-opacity"
      >
        ← Back to Dashboard
      </button>
      <div className="text-2xl font-bold">Score: {score}</div>
    </header>
  );
};